// Libs
import { createSelector } from 'reselect';

const selectClients = state => state.clients;

export const selectCreateClient = createSelector(
	[selectClients],
	clients => clients.createClient,
);
